// imports
import Config from '$root/Config';
import WindowResizeMixin from '$mixins/window-resize-mixin';

// private statics
const logKey = 'Is Mobile Mixin';

export default {
	mixins: [WindowResizeMixin],

	created() {},

	mounted() {
		this._is_mobile_checkIfMobile();
	},

	data() {
		return {
			is_mobile: false,
			is_tablet: false,
			is_mobileAt: Config.isMobileAt,
			is_tabletAt: Config.isTabletAt,
		};
	},

	beforeUnmount() {},

	methods: {
		// Override onWindowResize from WindowResizeMixin
		onWindowResize() {
			this._is_mobile_checkIfMobile();
		},

		_is_mobile_checkIfMobile() {
			this.is_mobile = window.innerWidth <= this.is_mobileAt;
			this.is_tablet = !!(window.innerWidth <= this.is_tabletAt && window.innerWidth >= this.is_mobileAt);
		},
	},
};
